import { Platform } from 'react-native';

export const isAndroid5 = () => {
  return Platform.OS === 'android' && Platform.Version === 21;
};

export const isAndroid6 = () => {
  return Platform.OS === 'android' && Platform.Version === 23;
};

export const isAndroid8 = () => {
  return Platform.OS === 'android' && [26, 27].some(x => x == Platform.Version);
};

export const isAndroid15 = () => {
  return Platform.OS === 'android' && Platform.Version === 35;
};
